<template>
  <div class="login-screen">
    <div class="layout" v-if="!settingsVisible">
      <img :src="logoURL" alt="" class="ld-logo">
      <div id="date">{{ this.date }}</div>
      <md-tabs id="login-tabs" class="md-accent" @md-changed="setTab" :md-active-tab="selectedTab" md-alignment="fixed" style="background: transparent; color: transparent;">
        <md-tab id="visitor" :md-label="$t('Gast')" style="background: transparent; color: transparent;">
          <div class="ld-content">
            <md-field>
              <input id="nickname" class="ld-input" @input="changeNickname()" autocomplete="off" maxlength=30 required :placeholder="$t('Anzeigename')"/>
            </md-field>
          </div>
        </md-tab>
        <md-tab id="moderator" :md-label="$t('Moderator')" style="background-color: transparent">
          <div class="ld-content">  
            <div class="ld-email-container">
              <md-field>
                <input id="email" class="ld-input inline" @input="changeEmail()" autocomplete="off" type="email" required :placeholder="$t('Email')"/>
              </md-field>
            </div>
            <div class="ld-password-container">
              <md-field>
                <input id="password" class="ld-input inline" @input="changePassword()" :placeholder="$t('Passwort')" type="password" required>
              </md-field>
            </div> 
          </div>
        </md-tab>
      </md-tabs>
      <span id="login-error" class="error"></span>
      <div class="button-container">
      <!-- <md-button class="normal-md-button" style="font-size: 16px; height: 45px; width: 80%;margin-right: 20px;" @click="cancel()" >{{$t('Abbrechen')}}</md-button> -->
      <md-button @click="proceed()" :disabled="!btnDisabled" class="accent-md-button" style="font-size: 16px; height: 45px; width: 100%;">{{$t('Weiter')}}</md-button>
      </div>
    </div>
    <AudioVideoDialogue v-else :from="'login'" :loginDialogueVisible="this.loginDialogueVisible" :settingsVisible="this.settingsVisible" :toggleLogin="this.toggleLogin" :toggleSettingsInLogin="this.toggleSettings"></AudioVideoDialogue>
  </div>
</template>
 
<script>
import {getInitials} from "@/utils/string-utils";
import MediaManager from "@/api/MediaManager";
import {mapGetters} from 'vuex';
import AudioVideoDialogue from "@/components/flux360/LoginComponents/AudioVideoDialogue";

export default {
  components: {AudioVideoDialogue},
  inject: ['toggleLoginDialogue', 'toggleCommunication'],
  props: {
    toggleLogin: Function,
    toggleLoginDialogue: Function,
    loginDialogueVisible: Boolean,
  },
	data: () => ({
    nickname: null,
    email: null,
    password: null,
    selectedTab: "visitor", // moderator || visitor
    status: 'start',
    settingsVisible: false,
    connect: undefined,
    btnDisabled: false,
	}),
  computed: {
    ...mapGetters(['panoramaTour', 'localUser', 'users', 'localUserID','logoURL']),
    date: function () {
      let date = new Date();
      return ("0" + date.getDate()).slice(-2) + "." + ("0" + (date.getMonth() + 1)).slice(-2) + "." + date.getFullYear();
    },
  },
  mounted() {
    let self = this;
    document.onkeydown = function(event){
      if(event.key === 'Enter' && self.loginDialogueVisible && !self.settingsVisible && document.getElementById("login-error") && (self.isLoginValid() || self.isNickValid())){
        self.proceed();
      }
    }
    this.$store.commit('setVideoOn', false);
    this.$store.commit('setAudioOn', false);
  },
  methods: {
    cancel() {
      const self = this;
      let userToBeRemoved = [];
      this.users.forEach((u) => {
        if(u.id !== self.localUserID){
          userToBeRemoved.push(u.id);
        }
      });
      userToBeRemoved.forEach((id) => {
        self.$store.commit("removeUser", id);
      });
      this.toggleLoginDialogue();
    },
    isValid() {
      if(this.selectedTab === "visitor")
        return this.isNickValid();
      else
        return this.isLoginValid();      
    },
    changeNickname(){
      this.nickname = document.getElementById("nickname") ? document.getElementById("nickname").value : null;
      this.isValid();
    },
    changeEmail(){
      this.email = document.getElementById("email") ? document.getElementById("email").value : null;
      this.isValid();
    },
    changePassword(){
      this.password = document.getElementById("password") ? document.getElementById("password").value : null;
      this.isValid();
    },
    isNickValid() {
      let valid = this.nickname && this.nickname.length >= 2;
      this.btnDisabled = valid;
      return valid;
    },
    isLoginValid() {
      let valid = this.email && this.password;
      this.btnDisabled = valid;
      return valid;
    },
    setTab(id) {
      this.selectedTab = id;
      this.isValid();
    },
    toggleSettings() {
      this.settingsVisible = !this.settingsVisible;
    },
    proceed() {
      document.getElementById("login-error").innerText = "";
      this.localUser.setRole(this.selectedTab);
      switch (this.selectedTab) {
        case 'visitor': {
          const name = this.nickname;
          const acronym = getInitials(name);
          // Note: this will create an OpenTok session if none exits.
          this.connect = this.$store.dispatch('changeNameAndAcronym', {name, acronym});
        }
          break;

        case 'moderator': {
          this.connect = this.$store.dispatch('logInAtCms', {
            email: this.email,
            password: this.password
          });
        }
          break;
      }
      this.connect.then(() => {
        console.log(`Logged in as ${this.selectedTab}`);
        MediaManager.getUserAvatar(this.localUser);
        this.status = 'settings';
        this.nickname = "";
        this.email = "";
        this.password = "";
        this.toggleSettings();
      }).catch(function (e) {
        if(e.message === "Login Error"){
          document.getElementById("login-error").innerText = 'Die Email und/oder das Passwort ist falsch.';
        }
        console.log(e);
      });
    },
	},
}
</script>

<style>
.login-screen {
  position: absolute;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(20px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(58, 58, 58, 0.8);
  color: white;
  z-index: 2;
  overflow-y: auto;
}
@-moz-document url-prefix() {
  .login-screen{
    background: rgba(68, 68, 68, 0.96);
  }
}
.layout{
  height: 100%;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 0 auto;
  padding-top: 2%;
}
.layout > *{
  margin-bottom: 5px;
}
.title {
  color: white;
  font-size: 2em;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 30px;
}
#date{
  color: #d0d0d0;
  font-size: 1em;
  text-align: center;
  margin-bottom: 50px;
}
.md-button{
  text-transform: none;
}
.ld-logo{
  margin-bottom: 20px;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.226));
}
.login-screen .md-tabs-navigation > .md-button{
  background-color: rgba(57, 56, 56, 0.8) ;
  border-radius: 0;
  width: 50%;
  font-size: 18px;
}
.login-screen .md-tabs-content{
  min-height: 190px;
}
.login-screen .md-tabs{
  --md-theme-default-accent-on-background: transparent;
  --md-theme-default-background: transparent;
}
.ld-input{
  color: white;
  background: rgba(36, 36, 36, 0.4);
  margin-top: 5px;
  height: 30px;
  width: 100%;
  border-radius: 3px;
  border: 0;
  padding-left: 12px;
}
.ld-input:focus{
  padding: 10px;
  border: 2px solid var(--primaryColor);
  outline: none;
}
.md-field{
  margin: 0;
  padding: 0;
}
.md-field.md-focused label{
  font-size: 1em;
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  .ld-input{
    font-size: 17px;
    min-height: 40px;
  }
  .md-field .md-toggle-password{
    height: 42px;
    width: auto;
  }
}
#nickname::placeholder, #email::placeholder, #password::placeholder{
  color: #b1b1b1;
}
.md-field.md-has-password .md-toggle-password{
  margin-top: 5px;
}
.md-field.md-has-value label{
  font-size: 1em;
  -webkit-text-fill-color: #808080;
}
.md-field.md-required label:after{
  all: unset;
}
.md-field.md-theme-default::after{
  background-color: transparent;
}
.md-focused{
  -webkit-text-fill-color: #b3b3b3;
  color: transparent;
}
.md-count{
  -webkit-text-fill-color: #808080;
}
.md-field.md-theme-default::before{
  background-color: transparent;
}
.md-field.md-theme-default.md-focused .md-count{
  -webkit-text-fill-color: white;
}
.md-field.md-theme-default.md-focused label{
  color: #808080;
  --md-theme-default-primary-on-background: #808080;
  -webkit-text-fill-color: white;
}
.md-has-password .md-button{
  padding: 0;
}
.error{
  color: #b1b1b1;
  font-size: 0.9em;
}
.button-container{
  display: flex;
  justify-content: center;
}
.login-screen label{
  color: white;
  margin-right: 10px;
  display: block;
}
.ld-content{
  min-height: 100px;
  margin-top: 10px;
}
.ld-email-container{
  margin-bottom: 20px;
}
@media screen and (max-width: 800px){
  .ld-content{
    min-height: 0;
  }
  .login-screen .md-tabs-content{
    min-height: 0;
  }
}
</style>